import { BulkActionResultTabs } from "components/BulkActions/types";
import EmptyState from "ds/components/EmptyState";
import { EmptystateSearchNoResultsColored } from "components/icons/generated";

type BulkActionsDrawerResultsStepBodyEmptyTabProps = {
  currentTab: BulkActionResultTabs;
};

const EMPTY_STATE_TITLE: Record<BulkActionResultTabs, string> = {
  [BulkActionResultTabs.Completed]: "No completed results",
  [BulkActionResultTabs.Failed]: "No failed results",
  [BulkActionResultTabs.Pending]: "All items processed",
};

const BulkActionsDrawerResultsStepBodyEmptyTab = ({
  currentTab,
}: BulkActionsDrawerResultsStepBodyEmptyTabProps) => {
  return (
    <EmptyState
      title={EMPTY_STATE_TITLE[currentTab]}
      icon={EmptystateSearchNoResultsColored}
      fullHeight
    />
  );
};

export default BulkActionsDrawerResultsStepBodyEmptyTab;
